import { Carousel, Card } from "react-bootstrap";
import img1 from "../../../../assets/images/exalumno1.jpg";
import img2 from "../../../../assets/images/edifi10.jpg";
import img3 from "../../../../assets/images/colegio1.jpg";

const imagenesExalumnos = [
  { src: img1, alt: "Historia 1" },
  { src: img2, alt: "Historia 2" },
  { src: img3, alt: "Historia 3" },
];

function HistoriaSection() {
  return (
    <div className="container my-5">
      <Card className="bg-dark text-white shadow-lg border-0 rounded-4 p-4" data-aos="fade-right">
        <Card.Body>
          <h2 className="text-center fw-bold mb-4" style={{ color: "yellow" }}>
            Historia
          </h2>
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4">

            {/* Carrusel a la izquierda */}
            <div className="w-100" style={{ maxWidth: "500px", height: "500px", overflow: "hidden" }}>
              <Carousel className="shadow-lg rounded-3">
                {imagenesExalumnos.map((imagen, index) => (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100"
                      src={imagen.src}
                      alt={imagen.alt}
                      style={{
                        height: "500px",
                        objectFit: "cover",
                        borderRadius: "10px",
                      }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>

            {/* Texto a la derecha */}
            <div
              className="mt-4 mt-md-0"
              style={{
                maxWidth: "600px",
                textAlign: "justify",
                color: "#f8f9fa",
                fontSize: "16px",
                lineHeight: "1.6",
              }}
            >
              <p>
                El Colegio Santo Tomás comenzó a funcionar el 15 de marzo de 1982, fundado por un grupo de docentes y madres de alumnos.
                Aspiraban a una enseñanza integral que armonizara la currícula oficial con inglés, deportes y catequesis.
              </p>
              <p>
                Este grupo estuvo formado por María Ofelia Garat del Carril, Carolina Castro de Maza,
                María Cristina Etcheverry de Marull, María Julia Berongharay de del Carril, María Lara Casella de Inurrigarro
                y Oristela Francia de Iglesias.
              </p>
              <p>
                Durante 1981 trabajaron en el proyecto y obtuvieron la aprobación por decreto N°5 del 12 de enero de 1982.
                Las clases comenzaron con 15 alumnos en una casa frente al diario La Arena.
              </p>
              <p>
                En 1984 se trasladaron al edificio actual de calle Estrada. Fueron creciendo año a año hasta
                llegar al 7º grado en 1987, egresando la primera promoción.
              </p>
              <p>
                En 1990, frente a la crisis, se reorganizan como Asociación Civil sin fines de lucro,
                accediendo a subsidios estatales.
              </p>
              <p>
                En 1995 se incorpora el Nivel Inicial, en 1997 se amplía a 9º año, y en el 2000 se crea el Polimodal
                con orientación en Ciencias Sociales y Humanas.
              </p>
              <p>
                <strong>Ideario:</strong> El colegio se basa en valores como autovaloración, conocimiento de Dios,
                competencias y formación moral. Se respeta la individualidad, promoviendo aprendizajes significativos
                y libertad responsable.
              </p>
              <p>
                La educación es entendida como un proceso de superación que permite al alumno descubrir y desarrollar
                sus capacidades personales.
              </p>
              <p>
                Los horarios particulares de la jornada de la mañana, correspondientes a cada año, se informan previo
                al inicio del ciclo lectivo.
              </p>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default HistoriaSection;
